module.exports = __webpack_public_path__ + "img/coat_1.5c34d93a.png";